import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ProgrammesListComponent } from './programmes-list/programmes-list.component';

const routes: Routes = [
  {
    path: 'programmes-list',
    component: ProgrammesListComponent,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ProgrammesInfoRoutingModule {}
